export const SocialTypes = {
  GOOGLE: "google",
  FACEBOOK: "facebook",
}

export const HTTP_METHODS = {
  GET: "GET",
  POST: "POST",
  PUT: "PUT",
  DELETE: "DELETE",
}

export const SocialAppIdentification = {
  // GOOGLE_CLIENT_ID : '409745368721-6vp6eltu29gegud4ncndjvaer2qpddru.apps.googleusercontent.com'
  GOOGLE_CLIENT_ID: "962676605809-uuaohois96ffhi5nfct5t0l60b7ilk55.apps.googleusercontent.com",
}

export const KEYS_STORAGE = {
  TOKEN: "token",
  PLAN: "plan",
  COMPANY: "company",
  GSTData: "gstData",
  USER: "user",
}

export const KEYS_COOKIES = {
  SESSION: "counto_session",
  COOKIE_DOMAIN: window.location.hostname.includes("localhost") ? 'localhost' : "xion.ai",
}

export const CryptoSecretKey = "Xion"

export const ModalPopupIds = {
  NewFolder: "newfolder",
  RenameFolder: "renamefolder",
  MoveFolder: "movefolder",
  RemoveFolder: "removefolder",
  UploadFile: "uploadfile",
}

export const DOCUMENT_DATA_TYPES = {
  INVOICE: "INVOICE",
  RECEIPT: "RECEIPT",
  DEBIT_NOTE: "DEBIT_NOTE",
  CREDIT_NOTE: "CREDIT_NOTE",
  IMPORT_PERMIT: "IMPORT_PERMIT",
  OTHER: "OTHER",
  BANK_STATEMENT: "BANK_STATEMENT",
}

export const DragType = {
  Folder: "folder",
  Document: "document",
}

export const WorkflowType = {
  Draft: "Draft",
  Reviewed: "Reviewed",
  Approved: "Approved",
  Archived: "Archived",
}

export const BankStatementStatus = {
  DRAFT: "DRAFT",
  FOR_REVIEW: "FOR_REVIEW",
  REVIEWED: "REVIEWED",
  APPROVED: "APPROVED",
  IGNORED: "IGNORED",
  ACCOUNTED: "ACCOUNTED",
  ARCHIVED: "ARCHIVED",
}

export const NextBankStatementStatus = {
  DRAFT: "FOR_REVIEW",
  FOR_REVIEW: "REVIEWED",
  REVIEWED: "APPROVED",
  APPROVED: "IGNORED",
  IGNORED: "ACCOUNTED",
  ACCOUNTED: "ARCHIVED",
}

export const BankStatementActiveTabStatus = {
  0: "DRAFT",
  1: "FOR_REVIEW",
  2: "REVIEWED",
  3: "APPROVED",
  4: "IGNORED",
  5: "ARCHIVED",
}

export const SideViewTabs = {
  ACTIONS: "ACTIONS",
  RULES: "RULES",
  FORMS: "FORMS",
  TABLE: "TABLE",
  ERRORS: "ERRORS",
  0: "ACTIONS",
  1: "RULES",
  2: "FORMS",
  3: "TABLE",
  4: "ERRORS",
}

export const CompanyTabs = {
  CreateCompany: "create",
  User: "user",
  Billing: "billing",
  Account: "account",
  Documents: "documents",
}

export const BillingScreen = {
  BillingHistory: "BillingHistory",
  BillingDetail: "BillingDetail",
  BillingEstimate: "BillingEstimate",
  BillingOverview: "BillingOverview",
}

export const CreditNoteDefinedField = [
  "Credit Note Number",
  "Credit Note Date",
  "CD Note Number",
  "CD Note Date"
]

export const DebitNoteDefinedField = [
  "DN Note Number",
  "DN Note Date",
  "Debit Note Number",
  "Debit Note Date"
]

export const ImportPermitDefinedField = [
  "Permit No",
  "Permit Date",
  "Currency",
  "Importer Name",
  "Importer UEN",
  "Exporter Name",
  "Exporter UEN",
  "Place of Receipt",
  "Total Wt / Unit",
  "Total Qty",
  "Tax Amount",
  "PreTax Amount",
  "Total",
  "Total Amount",
]

export const InvoiceDefinedField = [
  "Invoice Number",
  "Customer Name",
  "Supplier Name",
  "Currency",
  "Invoice Date",
  "ID",
  "Date",
  "Total",
  "PreTax Amount",
  "Tax Amount",
  "GST Registration Number",
  "Title",
  "Bank",
  "StatementInternalID",
]

export const InvoiceDateFields = {
  "Invoice Date": "dp_InvoiceDate",
  Date: "dp_Date",
  "Permit Date": "dp_PermitDate",
  "DN Note Date": "dp_DNNoteDate",
  "Debit Note Date": "dp_DNNoteDate",
  "Credit Note Date": "dp_CDNoteDate",
  "CD Note Date": "dp_CDNoteDate",
}

export const AutoCompleteField = {
  "Customer Name": "customer_name",
  "Supplier Name": "supplier_name",
}

export const FieldsMaxLength = {
  "Customer Name": 100,
  "Supplier Name": 100,
  "GST Registration Number": 16,
  "Invoice Number": 50,
  "Permit No": 20,
  Currency: 3,
}

export const InvoiceValueField = [
  "PreTax Amount",
  "Tax Amount",
  "Total"
]

export const CreditNoteRequiredField = ["Credit Note Date", "CD Note Date"]

export const DebitNoteRequiredField = ["DN Note Date", "Debit Note Date"]

export const ImportPermitRequiredField = ["Permit Date"]

export const RequiredFormsField = [
  "Date",
  "Invoice Date",
  "PreTax Amount",
  "Total",
  "Currency"
]

export const CommonEnums = {
  COMPUTE: "COMPUTE",
  RED: "RED",
  GREEN: "GREEN",
  BLUE: "BLUE",
  ORANGE: "ORANGE",
}

export const MoveType = {
  FILE: "FILE",
  FOLDER: "FOLDER",
}

export const ProductType = {
  GSTAUDIT: "GSTAudit",
  TAXASSIST: "TaxAssist",
  VAULT: "Vault",
}

// live
export const PublishableKey = "pk_live_l5k7qu9N3SUITIdfc5GXE6Uw00hVOwwBTy";
export const StripeSecretKey = "sk_live_Js5WnvHzfhII3BLgR2hR15Xe00dYdtl8XR";
export const EmailDomain = "@mycountomail.com";
export const IntercomAppId = "lpkxxmxb";

// //dev
// export const EmailDomain = "+dev@mycountomail.com";
// export const StripeSecretKey = "sk_test_rnLtR0zpV9KN9sQuzbAfRV2500NYrL3Pzb";
// export const PublishableKey = "pk_test_6nee4iHJS8jEiAmUbKcd41Ey00qbE5nmXT";
// export const IntercomAppId = "frwff535";

export const PlanType = {
  SMALLPLAN: 1,
  MEDIUMPLAN: 2,
  LARGEPLAN: 3,
}

export const UserRole = {
  SUPER_ADMIN: "SUPER_ADMIN",
}

export const AdjustmentType = {
  SUPPLIES_STAFF: "SUPPLIES_STAFF",
  SALES_BUSSINESS_ASSETS: "SALES_BUSSINESS_ASSETS",
  DEEMED_SUPPLIES: "DEEMED_SUPPLIES",
  OTHERS_SUPPLIES: "OTHERS_SUPPLIES",
  ZERO_RATED_BANK_DEPOSITS: "ZERO_RATED_BANK_DEPOSITS",
  EXEMPT_SUPPLIES_BANK_DEPOSITS: "EXEMPT_SUPPLIES_BANK_DEPOSITS",
  EXEMPT_SUPPLIES_FOREIGN_TRANSACTIONS: "EXEMPT_SUPPLIES_FOREIGN_TRANSACTIONS",
  GST_DEBTS_RECEIVED: "GST_DEBTS_RECEIVED",
  BED_DEBTS_RELIEF: "BED_DEBTS_RELIEF",
  INPUT_TAX_CLAIMED: "INPUT_TAX_CLAIMED",
}

export const AdjustmentTaxCode = {
  SUPPLIES_STAFF: "SR",
  SALES_BUSSINESS_ASSETS: "SR",
  DEEMED_SUPPLIES: "DS",
  OTHERS_SUPPLIES: "SR",
}

export const AdjustmentInvoiceCode = {
  SUPPLIES_STAFF: "SS",
  SALES_BUSSINESS_ASSETS: "SBA",
  DEEMED_SUPPLIES: "DS",
  OTHERS_SUPPLIES: "OS",
}

export const AdjustmentDescriptionLength = {
  SUPPLIES_STAFF: 180,
  SALES_BUSSINESS_ASSETS: 174,
  DEEMED_SUPPLIES: 182,
  OTHERS_SUPPLIES: 191,
}

export const AdjustmentDescriptionCategory = {
  SUPPLIES_STAFF: "Supplies to Staff -",
  SALES_BUSSINESS_ASSETS: "Sale of Business Assets -",
  DEEMED_SUPPLIES: "Deemed Supplies -",
  OTHERS_SUPPLIES: "Others -",
}

export const GstBoxesType = {
  Box1: 1,
  Box2: 2,
  Box3: 3,
  Box4: 4,
  Box5: 5,
  Box6: 6,
  Box7: 7,
  Box8: 8,
  Box9: 9,
  Box10: 10,
  Box11: 11,
  Box12: 12,
  Box13: 13,
  Box14: 14,
  Box15: 15,
  Box16: 16,
  Box17: 17,
  Box18: 18,
  Box19: 19,
  Box20: 20,
  Box21: 21,
}

export const PermissionType = {
  VIEW_ONLY: "VIEW_ONLY",
  STANDARD: "STANDARD",
  ELEVATED: "ELEVATED",
  ADMIN: "ADMIN",
}

export const AccountingSoftwareType = {
  Xero: "Xero",
  Quickbooks: "Quickbooks",
}

export const CsvColumns = {
  "Invoice Number": "invoiceNumber",
  "Invoice Date": "invoiceDate",
  "PreTax Amount": "preTaxAmount",
  "Tax Amount": "taxAmount",
  Total: "total",
  "Contact Name": "clientName",
  Currency: "currency",
  Account: "accountType",
  Description: "description",
  "Contact GSTNumber": "contactGSTNumber",
}

export const BillingStatus = {
  TRIALING: "trialing",
  TRIAL_ENDED: "trial_ended",
  INCOMPLETE: "incomplete",
  INCOMPLETE_EXPIRED: "incomplete_expired",
  ACTIVE: "active",
  PAST_DUE: "past_due",
  CANCELED: "canceled",
  UNPAID: "unpaid",
}

export const KeyMatrixHeadings = [
  "income",
  "Gross Profit Margin",
  "Net Income",
  "Expenses",
  "Net Profit Margin",
  "Cost of Sales",
  "Gross Profit"
]

export const DATATABLE_FILTERS_VALUES = {
  FLAG_YES: 'Flag',
  FLAG_NO: 'No Flag',
  NOTE_EMPTY: 'Empty',
  NOTE_FILLED: 'Filled',
}
